"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractPersistableItemInstanceData = extractPersistableItemInstanceData;
function extractPersistableItemInstanceData(itemType, _data) {
    switch (itemType) {
        case "FileUploadV2": {
            const data = _data;
            return {
                files: (data.files ?? []).map((file) => ({
                    identifier: file.identifier,
                    originalBasename: file.originalBasename,
                    extension: file.extension,
                    mime: file.mime,
                    type: file.type,
                })),
            };
        }
        case "Signature": {
            const data = _data;
            return {
                svgPaths: data.svgPaths,
            };
        }
        default:
            return _data;
    }
}
//# sourceMappingURL=ItemData.js.map